import React, { useState, useEffect } from "react";

import AuthService from "../../../../class/services/AuthService";

import UserService from "../../../../class/User/UserService";
import UserServices from "../../../../class/User_copy/UserService";

import { useTranslation } from "react-i18next";

const Bet_history_casino = () => {
    const { t } = useTranslation();

    const user_id = AuthService.getCustom("user_id");
    const currency = AuthService.getCustom("currency");

    const [isLoading, setIsLoading] = useState(false);

    const [bets, setBets] = useState([]);

    const [filter_by, setFilter_by] = useState("1 Month Ago");

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState([]);

    const [resetEnabled, setresetEnabled] = useState(false);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const formatCurrency = (amount, currencyCode) => {
        return new Intl.NumberFormat("it-IT", {
            style: "currency",
            currency: currencyCode,
        }).format(amount);
    };

    const loadBets = async (page = 1) => {
        setIsLoading(true);

        try {
            const data = await UserServices.getBet(
                user_id,
                currency,
                "",
                startDate,
                endDate,
                page,
                10,
            );

            // console.log("Fetched bets data:", data);

            if (data.params.count > 0) {
                setBets(data.params.bets || []);

                setTotalPages(data.params.total_pages || []);
            } else {
                setBets([]);
                setTotalPages([]);
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        } finally {
            setIsLoading(false); // Set loading to false after API call completes
        }
    };

    useEffect(() => {
        loadBets(currentPage);
    }, [currentPage, startDate, endDate]);

    const handlePageChange = (page) => {
        if (page !== currentPage && page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleCustomDateChange = (event) => {
        const { name, value } = event.target;
        setFilter_by("Custom");

        const date = new Date(value);
        const formattedDate = `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;

        if (name === "start") {
            setStartDate(formattedDate);
        } else {
            setEndDate(formattedDate);
        }
    };

    const handleDateFilterChange = (event) => {
        const filter = event.target.value;
        const now = new Date();
        let start, end;

        if (filter === "1week") {
            start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            end = now;
            setFilter_by("1 Week Ago");
        } else if (filter === "2weeks") {
            start = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
            end = now;
            setFilter_by("2 Weeks Ago");
        } else if (filter === "1month") {
            start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            end = new Date(now.getFullYear(), now.getMonth(), 0);
            setFilter_by("1 Month Ago");
        } else if (filter === "custom") {
            start = "";
            end = "";
        }

        setresetEnabled(true);

        if (start) start.setHours(0, 0, 0, 0);
        if (end) end.setHours(23, 59, 59, 999);

        const formatToServerDate = (date) =>
            `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`;

        setStartDate(start ? formatToServerDate(start) : "");
        setEndDate(end ? formatToServerDate(end) : "");

        setCurrentPage(1);
    };

    const renderPagination = () => {
        const paginationItems = [];
        const lastPage = totalPages;

        // Очищення старих елементів
        const uniquePages = new Set();

        // Перша сторінка завжди відображається
        paginationItems.push(
            <li
                key="page-1"
                className={`page-item ${currentPage === 1 ? "active" : ""}`}
            >
                <a
                    className="page-link"
                    href="#"
                    onClick={() => handlePageChange(1)}
                >
                    1
                </a>
            </li>,
        );
        uniquePages.add(1);

        if (currentPage > 3 && !uniquePages.has("start-ellipsis")) {
            paginationItems.push(
                <li key="start-ellipsis" className="page-item disabled">
                    <a className="page-link">...</a>
                </li>,
            );
            uniquePages.add("start-ellipsis");
        }

        for (
            let i = Math.max(2, currentPage - 1);
            i <= Math.min(currentPage + 1, lastPage - 1);
            i++
        ) {
            if (!uniquePages.has(i)) {
                // Перевірка на унікальність
                paginationItems.push(
                    <li
                        key={`page-${i}`}
                        className={`page-item ${currentPage === i ? "active" : ""}`}
                    >
                        <a
                            className="page-link"
                            onClick={() => handlePageChange(i)}
                        >
                            {i}
                        </a>
                    </li>,
                );
                uniquePages.add(i);
            }
        }

        if (currentPage < lastPage && !uniquePages.has(currentPage + 1)) {
            paginationItems.push(
                <li key={`page-${currentPage + 1}`} className="page-item">
                    <a
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        {currentPage + 1}
                    </a>
                </li>,
            );
            uniquePages.add(currentPage + 1);
        }

        if (currentPage < lastPage - 1 && !uniquePages.has("end-ellipsis")) {
            paginationItems.push(
                <li key="end-ellipsis" className="page-item disabled">
                    <a className="page-link">...</a>
                </li>,
            );
            uniquePages.add("end-ellipsis");
        }

        // Остання сторінка завжди відображається
        if (lastPage > 1 && !uniquePages.has(lastPage)) {
            paginationItems.push(
                <li
                    key={`page-${lastPage}`}
                    className={`page-item ${currentPage === lastPage ? "active" : ""}`}
                >
                    <a
                        className="page-link"
                        onClick={() => handlePageChange(lastPage)}
                    >
                        {lastPage}
                    </a>
                </li>,
            );
            uniquePages.add(lastPage);
        }

        return paginationItems;
    };

    const handleReset = () => {
        setFilter_by("");
        setStartDate("");
        setresetEnabled(false);
        setEndDate("");
        setCurrentPage(1);
        setBets([]);
        setTotalPages([]);
    };

    return (
        <div>
            <div
                className="tab-pane fade show"
                id="casino-tab-pane"
                role="tabpanel"
                aria-labelledby="casino-tab"
                tabIndex="0"
            >
                <div className="form-online">
                    <section className="forms boxed-form">
                        <div className="form signup">
                            <div className="form-content">
                                <div className="header-form-content">
                                    <h3>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="-21 -133 682.66669 682"
                                        >
                                            <g fillRule="evenodd">
                                                <path d="m12.5 254.855469c6.90625 0 12.5-5.597657 12.5-12.5v-183.945313c0-22.375 18.203125-40.578125 40.578125-40.578125h508.84375c22.375 0 40.578125 18.203125 40.578125 40.578125 0 6.898438 5.59375 12.5 12.5 12.5s12.5-5.601562 12.5-12.5c0-36.164062-29.414062-65.578125-65.578125-65.578125h-508.84375c-36.164063 0-65.578125 29.414063-65.578125 65.578125v183.945313c0 6.902343 5.59375 12.5 12.5 12.5zm0 0" />
                                                <path d="m627.5 145.910156c-6.90625 0-12.5 5.59375-12.5 12.5v183.945313c0 22.371093-18.203125 40.574219-40.578125 40.574219h-508.84375c-22.375 0-40.578125-18.195313-40.578125-40.574219 0-6.898438-5.59375-12.5-12.5-12.5s-12.5 5.601562-12.5 12.5c0 36.160156 29.414062 65.574219 65.578125 65.574219h508.84375c36.164063 0 65.578125-29.414063 65.578125-65.574219v-183.945313c0-6.90625-5.59375-12.5-12.5-12.5zm0 0" />
                                                <path d="m563.316406 64.484375h-486.628906c-6.902344 0-12.5 5.59375-12.5 12.5v246.796875c0 6.902344 5.597656 12.5 12.5 12.5h486.628906c6.902344 0 12.5-5.597656 12.5-12.5v-246.796875c0-6.90625-5.597656-12.5-12.5-12.5zm-474.128906 25h137.210938v221.796875h-137.210938zm162.210938 0h137.203124v221.796875h-137.203124zm299.417968 221.796875h-137.214844v-221.796875h137.214844zm0 0" />
                                                <path d="m195.90625 124.441406h-76.226562c-6.90625 0-12.5 5.597656-12.5 12.5v11.511719c0 6.898437 5.59375 12.5 12.5 12.5 6.566406 0 11.957031-5.074219 12.460937-11.511719h36.851563c-18.609376 24.515625-44.953126 67.425782-45.316407 114.285156-.050781 6.90625 5.503907 12.539063 12.402344 12.59375h.097656c6.863281 0 12.449219-5.53125 12.5-12.402343.464844-60.777344 55.585938-117.648438 56.136719-118.203125 3.539062-3.589844 4.570312-8.949219 2.625-13.597656-1.945312-4.648438-6.492188-7.675782-11.53125-7.675782zm0 0" />
                                                <path d="m358.117188 124.441406h-76.234376c-6.902343 0-12.5 5.597656-12.5 12.5v11.511719c0 6.898437 5.597657 12.5 12.5 12.5 6.574219 0 11.960938-5.074219 12.460938-11.511719h36.859375c-18.617187 24.515625-44.957031 67.425782-45.320313 114.285156-.054687 6.90625 5.503907 12.539063 12.40625 12.59375h.101563c6.851563 0 12.4375-5.53125 12.492187-12.402343.464844-60.777344 55.59375-117.648438 56.140626-118.203125 3.53125-3.589844 4.570312-8.949219 2.625-13.597656-1.949219-4.648438-6.492188-7.675782-11.53125-7.675782zm0 0" />
                                                <path d="m444.09375 160.953125c6.570312 0 11.957031-5.074219 12.460938-11.511719h36.851562c-18.609375 24.515625-44.953125 67.425782-45.3125 114.285156-.050781 6.90625 5.5 12.539063 12.40625 12.59375h.09375c6.863281 0 12.449219-5.53125 12.496094-12.402343.46875-60.777344 55.589844-117.648438 56.136718-118.203125 3.542969-3.589844 4.570313-8.949219 2.628907-13.597656-1.941407-4.648438-6.496094-7.675782-11.527344-7.675782h-76.230469c-6.90625 0-12.5 5.597656-12.5 12.5v11.511719c-.003906 6.90625 5.59375 12.5 12.496094 12.5zm0 0" />
                                                <path d="m12.5 304.855469c6.882812 0 12.5-5.617188 12.5-12.5 0-6.886719-5.617188-12.5-12.5-12.5s-12.5 5.613281-12.5 12.5c0 6.882812 5.617188 12.5 12.5 12.5zm0 0" />
                                                <path d="m627.5 95.910156c-6.882812 0-12.5 5.609375-12.5 12.5 0 6.882813 5.617188 12.5 12.5 12.5s12.5-5.617187 12.5-12.5c0-6.890625-5.617188-12.5-12.5-12.5zm0 0" />
                                            </g>
                                        </svg>

                                        {t("History_bet_casino")}
                                    </h3>
                                    <div className="select_filter">
                                        {resetEnabled && (
                                            <a
                                                className="reset-d-btn"
                                                onClick={handleReset}
                                            >
                                                <svg
                                                    viewBox="0 0 1920 1920"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" />
                                                </svg>
                                            </a>
                                        )}

                                        <div className="drop_dash dropdown">
                                            <a
                                                className="dropdown-toggle no-arrow"
                                                href="#"
                                                id="navbarDropdown"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <span id="selectedTitleDateSport">
                                                    {filter_by}
                                                </span>

                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 45.402 45.402"
                                                    xmlSpace="preserve"
                                                >
                                                    <path d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141                                  c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27                                  c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435                                  c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z" />
                                                </svg>
                                            </a>

                                            <div
                                                className="dropdown-menu dropdown-menu-end filter-section"
                                                aria-labelledby="navbarDropdown"
                                            >
                                                <div className="radio-group">
                                                    <input
                                                        id="1weekSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="1week"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="1weekSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("1_Week_Ago")}
                                                    </label>

                                                    <input
                                                        id="2weekSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="2weeks"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="2weekSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("2_Week_Ago")}
                                                    </label>

                                                    <input
                                                        id="1monthSelectSport"
                                                        type="radio"
                                                        name="radio-group-sport"
                                                        className="radio-input"
                                                        autoComplete="off"
                                                        value="1month"
                                                        onChange={
                                                            handleDateFilterChange
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="1monthSelectSport"
                                                        className="radio-label"
                                                    >
                                                        <span className="radio-inner-circle"></span>
                                                        {t("1_Month_Ago")}
                                                    </label>
                                                </div>

                                                {true && (
                                                    <div className="input-group input-daterange">
                                                        <input
                                                            type="date"
                                                            name="start"
                                                            className="form-control date_start_sport"
                                                            onChange={
                                                                handleCustomDateChange
                                                            }
                                                        />
                                                        <div className="input-group-text">
                                                            to
                                                        </div>
                                                        <input
                                                            type="date"
                                                            name="end"
                                                            className="form-control date_end_sport"
                                                            onChange={
                                                                handleCustomDateChange
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="responsive-table__upper-element right-shadow history bet2-column">
                                    <div className="responsive-table__left-shadow-el"></div>
                                    <div className="responsive-table__wrapper">
                                        <div className="responsive-table">
                                            <div className="responsive-table__cell responsive-table__header">
                                                {t("Date")}
                                            </div>
                                            <div className="responsive-table__cell responsive-table__header">
                                                {t("Description")}
                                            </div>
                                            {/* <div className="responsive-table__cell responsive-table__header">{t('Quantity')}</div>
                                            <div className="responsive-table__cell responsive-table__header">{t('ID')}</div> */}
                                            <div className="responsive-table__cell responsive-table__header responsive-table__cell--last-of-row">
                                                {t("Balance")}
                                            </div>

                                            {!isLoading &&
                                                bets.length > 0 &&
                                                bets.map((bet, index) => (
                                                    <React.Fragment key={index}>
                                                        <div
                                                            className={`responsive-table__cell sticky-cell ${index % 2 === 1 ? "" : ""}`}
                                                        >
                                                            {t("ID")}{" "}
                                                            <strong>
                                                                {bet.round_id}
                                                            </strong>
                                                            {/* {t('Balance')} <strong>{bet.ref_balance}</strong> */}
                                                            <small>
                                                                {new Date(
                                                                    bet.created_at *
                                                                        1000,
                                                                ).toLocaleString()}
                                                            </small>
                                                        </div>
                                                        <div
                                                            className={`responsive-table__cell ${index % 2 === 1 ? "" : ""}`}
                                                        >
                                                            {bet.game_name}
                                                            <small>
                                                                {
                                                                    bet.provider_name
                                                                }
                                                            </small>
                                                            {/* <small>Transaction ID: {bet.transaction_id}</small> */}
                                                            <small>
                                                                {
                                                                    bet.transaction_type
                                                                }
                                                            </small>
                                                            <div className="win-bet-box">
                                                                {bet.transaction_type ==
                                                                    "BET" &&
                                                                    bet.amount >
                                                                        0.0 && (
                                                                        <small>
                                                                            <span className="transaction_widthdraw">
                                                                                {formatCurrency(
                                                                                    bet.amount,
                                                                                    bet.currency_code,
                                                                                )}
                                                                            </span>
                                                                        </small>
                                                                    )}
                                                                {bet.transaction_type ==
                                                                    "WIN" &&
                                                                    bet.amount >
                                                                        0.0 && (
                                                                        <small>
                                                                            <span className="transaction_deposit">
                                                                                {formatCurrency(
                                                                                    bet.amount,
                                                                                    bet.currency_code,
                                                                                )}
                                                                            </span>
                                                                        </small>
                                                                    )}
                                                            </div>
                                                        </div>
                                                        {/*  <div className={`responsive-table__cell ${index % 2 === 1 ? 'responsive-table__cell--striped' : ''}`}>
                                            <span className={`transaction_${bet.transaction_type === 'WIN' ? 'deposit' : 'widthdraw'}`}>
                                                {bet.amount}
                                            </span>
                                        </div>
                                        <div className={`responsive-table__cell ${index % 2 === 1 ? 'responsive-table__cell--striped' : ''}`}>
                                            {bet.round_id}
                                        </div> */}
                                                        <div
                                                            className={`responsive-table__cell responsive-table__cell--last-of-row ${index % 2 === 1 ? "responsive-table__cell--striped" : ""}`}
                                                        >
                                                            {formatCurrency(
                                                                bet.after_balance,
                                                                bet.currency_code,
                                                            )}
                                                        </div>
                                                    </React.Fragment>
                                                ))}
                                        </div>
                                    </div>
                                </div>

                                {isLoading ? (
                                    <div className="content-loader-games">
                                        <div className="loader-spinner"></div>
                                        <p>{t("loading")}</p>
                                    </div>
                                ) : (
                                    bets.length === 0 && (
                                    <div className="no-content-search">
                                        <p>
                                            {t(
                                                "No_results_found_for_your_query.",
                                            )}
                                        </p>
                                    </div>
                                    )
                                )}

                                <div className="pagination_list_element">
                                    {bets.length > 0 && (
                                        <nav>
                                            <ul className="pagination">
                                                {/* Previous Page */}
                                                <li
                                                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                                >
                                                    <a
                                                        className="page-link"
                                                        onClick={() =>
                                                            handlePageChange(
                                                                currentPage - 1,
                                                            )
                                                        }
                                                        aria-label="Previous"
                                                    >
                                                        <span aria-hidden="true">
                                                            «
                                                        </span>
                                                    </a>
                                                </li>

                                                {/* Dynamic Page Buttons */}
                                                {renderPagination()}

                                                {/* Next Page */}
                                                <li
                                                    className={`page-item ${currentPage === totalPages.length ? "disabled" : ""}`}
                                                >
                                                    <a
                                                        className="page-link"
                                                        onClick={() =>
                                                            handlePageChange(
                                                                currentPage + 1,
                                                            )
                                                        }
                                                        aria-label="Next"
                                                    >
                                                        <span aria-hidden="true">
                                                            »
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Bet_history_casino;
